import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const TYRO_CONFIG_API_PATH = '/api/tyro-config';

const getTyroConfig = async (storeId, options = {}) => {
  const params = options.includeSensitive ? '?includeSensitive=true' : '';
  const response = await axios.get(`${API_BASE_URL}${TYRO_CONFIG_API_PATH}/${storeId}${params}`);
  return response.data.data;
};

const updateTyroConfig = async (storeId, configData) => {
  const response = await axios.put(`${API_BASE_URL}${TYRO_CONFIG_API_PATH}/${storeId}`, configData);
  return response.data.data;
};

const updateIntegrationKey = async (storeId, integrationKey) => {
  const response = await axios.put(
    `${API_BASE_URL}${TYRO_CONFIG_API_PATH}/${storeId}/integration-key`,
    { integrationKey }
  );
  return response.data.data;
};

const tyroConfigService = { getTyroConfig, updateTyroConfig, updateIntegrationKey };
export default tyroConfigService;
